import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ErrorHandler, provideZonelessChangeDetection } from "@angular/core";
import { Router } from "@angular/router";
import { ReferenceDataEffects, ReferenceDataFeature } from "@core/reference-data";
import { toastProviders } from "@core/toast";
import { RemitterEffects } from "@domains/remitter";
import { UserEffects, UserFeature } from "@features/user";
import { ScopedEntityEffects, ScopedEntityFeature } from "@features/scoped-entity";
import { antiforgeryTokenInterceptor } from "@interceptors/antiforgery-token";
import { errorResponseInterceptor } from "@interceptors/error-response";
import { withCredentialsInterceptor } from "@interceptors/with-credentials";
import { provideEffects } from "@ngrx/effects";
import { provideState, provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import * as Sentry from "@sentry/angular";
import { provideEnvironmentNgxMask } from "ngx-mask";

export const sharedProviders = [
	provideEnvironmentNgxMask(),
	provideZonelessChangeDetection(),
	provideHttpClient(
		withInterceptors([antiforgeryTokenInterceptor, withCredentialsInterceptor, errorResponseInterceptor])
	),
	provideEffects(ReferenceDataEffects, ScopedEntityEffects, RemitterEffects, UserEffects),
	provideStore(),
	provideState(ReferenceDataFeature),
	provideState(UserFeature),
	provideState(ScopedEntityFeature),
	provideStoreDevtools({ maxAge: 25, logOnly: false }),
	{
		provide: ErrorHandler,
		useValue: Sentry.createErrorHandler()
	},
	{
		provide: Sentry.TraceService,
		deps: [Router]
	},
	...toastProviders
];
